import React, { type FC } from 'react';

import { LICENSE } from 'app/constants/license';
import { Trans, useTranslation } from 'app/lang';
import { Anjouangaming } from 'app/lib/anjouangaming';
import { getBrandName } from 'app/packages/brand';
import { SkipSSR } from 'app/packages/components';

import dictionary from './License.dictionary.json';

import styles from './License.module.scss';

export const License: FC = () => {
  const brand = getBrandName();
  const { t } = useTranslation();

  if (!LICENSE[brand]) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.notice}>
        <p>
          <Trans data={dictionary.noticeText}
                 values={{ site: LICENSE[brand].site, email: LICENSE[brand].email }}
                 components={{
                   a: (
                     <a href={`mailto:${LICENSE[brand].email}`} />
                   ),
                 }} />
        </p>
        <SkipSSR>
          <Anjouangaming license={LICENSE[brand]}
                         className={styles.icon} />
        </SkipSSR>
      </div>
      <p>
        {t(dictionary.sportsbookText)}
      </p>
    </div>
  );
};
